import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Utils } from 'shared/utils/utils';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { PremiumExtendComponent } from 'shared/components/subscription/premium-extend/premium-extend.component';

@Component({
  selector: 'app-subscription-upgrade-alert-dialog',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatDialogModule, MatButtonModule, PremiumExtendComponent],
  templateUrl: './subscription-upgrade-alert-dialog.component.html',
  styleUrl: './subscription-upgrade-alert-dialog.component.scss'
})
export class SubscriptionUpgradeAlertDialogComponent {
  
  reason: 'LIMIT_EXCEEDED' = 'LIMIT_EXCEEDED'

  constructor(
    private _matDialog: MatDialogRef<SubscriptionUpgradeAlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) 
  {

    if(Utils.isDefined(data, "reason")) {
      this.reason = data.reason
    }

  }

  close() {
    this._matDialog.close()
  }
}
